import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRightArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 10,
	viewBox: "0 0 21 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5 9L13.075 7.6L15.175 5.5H0V3.5H15.175L13.1 1.4L14.525 0L19 4.5L14.5 9Z",
		fill: "currentColor"
	})
});
export default SvgRightArrow;
